<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :title="title"
    show-close
    width="400px"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :listGoodsSpec="listGoodsSpec"
      :masterCategoryCode="masterCategoryCode"
      @confirm="(e) => $emit('confirm', e)"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ this.$l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    masterCategoryCode: { type: String, default: '' },
    listGoodsSpec: { type: Array, default: () => {} },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
